import React from "react";
// import ContactForm from '../contact-form/ContactForm'

// CUSTOM CSS IMPORT
import "./contactUs.css";

const ContactUs = () => {
  return (
    <>
      {/* CONTACT US HEADING */}
      <div className="Header">
        <img
          className="img-fluid"
          src="./images/page-header/contact-page-header.jpg"
          alt="loading..."
          style={{ width: "100%" }}
        />
        <div className="centered" id="heading-centered">
          <h1 style={{ color: "white" }}> Contact Us</h1>
          <hr style={{ opacity: "1", color: "#ffbb33", width: "100px" }} />
        </div>
      </div>

      {/* PAGE CONTAINER */}
      <div className="contact-us-page-container">
        <h1
          className="page-heading text-center mt-5"
          style={{ color: "#000000" }}
        >
          SL Growth Engineering LLP, Kharghar
        </h1>
        <hr
          className="our-service-hr"
          style={{
            opacity: "1",
            color: "#ffbb33",
            maxWidth: "150px",
            height: "3px",
            margin: "10px auto",
          }}
        />
        <div className="container location-information mt-5">
          <div className="google-location">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4223.452380059467!2d72.8519484!3d19.2274637!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b0d61eb2542b%3A0x544165f4cba0a73e!2sSL%20Growth%20Engineering%20LLP!5e1!3m2!1sen!2sin!4v1759841916934!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              className="google-map container"
              title="google-map-borivali"
            ></iframe>
          </div>
          <div className="address p-3 ">
            <h2 className="text-center ">ADDRESS</h2>
            <div className="complete address pt-5">
              <p style={{ color: "#D9DDDC" }}>
                <i className="fas fa-home mr-3"></i> Borivali West, Maharashtra
                - 400092
              </p>
              <p style={{ color: "#D9DDDC" }}>
                <i className="fas fa-envelope mr-3"></i> info@slgrowthengg.com
              </p>
              <p style={{ color: "#D9DDDC" }}>
                <i className="fas fa-phone mr-3"></i> +91 - 9930453698
              </p>
              <p style={{ color: "#D9DDDC" }}>
                <i className="fas fa-phone mr-3"></i> +91 - 8850038347
              </p>
            </div>
          </div>
        </div>
      </div>

      {/*contact form  */}
      <div className="contact-form mt-5">{/* <ContactForm /> */}</div>
    </>
  );
};

export default ContactUs;
